import React from 'react'
import {MdDelete} from 'react-icons/md';
import {MdRefresh} from 'react-icons/md';
import {MdPerson} from 'react-icons/md';
import {
    Media,
    Badge,
    Button
} from "reactstrap";
import placeholderHelper from "../../helpers/PlaceholderHelper";
import {resource_strings} from "../../translations/resource_translations";
import LocalizedStrings from "react-localization";
import localeHelpers from "../../helpers/LocaleHelper";
import ReactTooltip from "react-tooltip";
import {student_strings} from "../../translations/student_translations";
import {isMobile, isTablet} from "react-device-detect";

let resourceStrings = new LocalizedStrings(resource_strings);
let studentStrings = new LocalizedStrings(student_strings);
const roundButton = {width: 50, height: 50, minWidth: 50, minHeight: 50, borderRadius: 25, padding: 0}
const propTypes = {};

class ClientTableRow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            client: props.client,
        };
    }

    localize() {
        const loc = localeHelpers.currentLocale();
        resourceStrings.setLanguage(loc);
        studentStrings.setLanguage(loc);
    }

    render() {
        this.localize();

        return (
            <div style={{
                display: "flex",
                flexFlow: "row",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                marginLeft: 20,
                marginRight: 20,
                marginTop: 10,
                marginBottom: 10,
                padding: 10,
                borderRadius: 40,
                backgroundColor: "#555566"
            }}
                 onClick={e => this.props.goToClient(e, this.state.client.id)}
            >
                <Media style={{
                    display: "flex",
                    flexFlow: "row",
                    alignItems: "center",
                    color: "white",
                    justifyContent: "start",
                    maxWidth: 400,
                    minWidth: 300,
                }}>
                    <a
                        className="avatar mr-3"
                        onClick={e => this.props.goToClient(e, this.state.client.id)}
                    >
                        <img
                            style={{cursor: "pointer"}}
                            alt="..."
                            src={this.state.client && this.state.client.photo ? this.state.client.photo : placeholderHelper.randomIcon()}
                        />
                    </a>

                    <div style={{
                        display: "flex",
                        flexFlow: "column",
                        alignItems: "left",
                        color: "white",
                        justifyContent: "left",
                        maxWidth: 400,
                    }}>
                        <div
                            className={this.state.client.is_archived ? "mb-0 text-sm text-through" : "mb-0 text-sm"}
                            style={{fontWeight: 600}}>
                            {this.makeName()}
                        </div>

                        <div className="mb-0 text-light" style={{fontSize: "0.7rem"}}>
                            {this.state.client && this.state.client.email ? this.state.client.email : ""}
                        </div>
                        <div>
                            {this.renderBadge()}
                        </div>
                    </div>
                </Media>

                <div>
                    {this.renderGroup()}
                </div>

                <div className="text-right align-content-end" style={isMobile && !isTablet ? {width: "100%"} : {}}>
                    <ReactTooltip/>
                    {this.state.client.is_archived ?
                        (<Button
                            style={roundButton}
                            className="btn-icon"
                            color="success"
                            data-type="warning"
                            data-tip={studentStrings.recover_client}
                            onClick={e => this.props.recoverClient(e, this.state.client.id)}>
                            <MdRefresh/>
                        </Button>)
                        :
                        (<Button
                            style={roundButton}
                            className="btn-icon"
                            color="warning"
                            onClick={e => this.props.deleteClient(e, this.state.client)}>
                            <MdDelete/>
                        </Button>)
                    }
                    <Button
                        style={roundButton}
                        color="secondary"
                        onClick={e => this.props.goToClient(e, this.state.client.id)}>
                        <MdPerson/>
                    </Button>

                </div>
            </div>
        )
    }

    renderBadge() {
        if (this.state.client.is_archived === true) {
            return <Badge color="" className="badge-dot">
                <i className="fas fa-trash text-danger"/>
            </Badge>
        } else if (this.state.client && this.state.client.active === true) {
            return <Badge color="" className="badge-dot">
                <i className="bg-success"/>
                {resourceStrings.active}
            </Badge>
        } else {
            return <Badge color="" className="badge-dot mr-4">
                <i className="bg-warning"/>
                {resourceStrings.no_active_ticket}
            </Badge>
        }
    }

    makeName() {
        const client = this.state.client
        let name = client && client.name ? client.name.replace("(archived)", "") : "..."
        if (client.class_count) {
            name += ` (${client.class_count} ${resourceStrings.classes})`
        }
        return name
    }

    hasRankAssigned() {
        return this.state.client && this.state.client['student_ranks.icon'] !== undefined && this.state.client['student_ranks.icon'] !== null
            && this.state.client['student_ranks.icon'].length > 0 && this.state.client['student_ranks.color'] !== undefined && this.state.client['student_ranks.color'] !== undefined
    }

    makeIcon() {
        return require(`assets/img/icons/ranks/${this.state.client['student_ranks.icon']}/${this.state.client['student_ranks.icon']}-${this.state.client['student_ranks.color']}.svg`);
    }

    renderGroup() {
        if (this.hasRankAssigned()) {
            return <div style={{display:"flex", flexFlow: "column", alignItems: "center"}}><div
                className="icon icon-shape bg-gradient-light rounded-circle" style={{width: 18, height: 18}}>
                <img
                    width={16}
                    height={16}
                    alt=""
                    src={this.makeIcon()}/>
            </div><span style={{fontSize: "0.7rem", color: "white", overflow: 'hidden', maxWidth: "100px", whiteSpace: 'nowrap'}}>{this.state.client['student_ranks.title']}</span></div>
        }
    }
}

ClientTableRow.propTypes = propTypes;

export default ClientTableRow;